export default {
  // AlternativeNamesView
  alternativeNames: 'Nombres Alternativos',

  // AlternativeNames
  editAlternativeName: 'Editar nombre alternativo',
  defaultSingularName: 'Nombre singular por defecto',
  defaultPluralName: 'Nombre plural por defecto',
  abbreviatedName: 'Nombre abreviado',
  singularArticle: 'Artículo singular',
  singularName: 'Nombre singular',
  pluralArticle: 'Artículo plural',
  pluralName: 'Nombre plural',

  // AlternativeNameForm
  selectArticle: 'Seleccione un artículo',
  mustSelectArticle: 'Debe seleccionar un artículo.',
  deleteAlternativeNameConfirmation: '¿Está seguro de que lo desea eliminar?',
  updated: 'Actualizado',
}
